/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { COLORS } from "../../shared/theme";

type Props = {
  height?: string;
  maxHeight?: string;
  backgroundColor?: string;
  alwaysVisible?: boolean;
  gutter?: number;
  leftGutter?: number;
  rightGutter?: number;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
};

export const Scrollable: React.FC<React.PropsWithChildren<Props>> = ({
  height,
  maxHeight,
  backgroundColor = "transparent",
  gutter = 8,
  leftGutter,
  rightGutter,
  onScroll,
  children,
}) => (
  <div
    css={css`
      width: 100%;
      padding-right: ${rightGutter !== undefined ? rightGutter : gutter / 2}px;
      background-color: ${backgroundColor};

      &:hover > div::-webkit-scrollbar-thumb {
        background-color: ${COLORS.BORDER};
      }
    `}
  >
    <div
      css={css`
        height: ${height};
        max-height: ${maxHeight};
        padding-right: ${leftGutter !== undefined ? leftGutter : gutter / 2}px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        &::-webkit-scrollbar-thumb {
          transition: all 1020ms ease;
          border-radius: 5px;
          background-color: transparent;
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
      `}
      data-cy="scrollable"
      onScroll={onScroll}
    >
      {children}
    </div>
  </div>
);
